module.exports = __webpack_public_path__ + "img/GA.c948b2bf.png";